<template>
    <div>
        <el-form-item prop="name" :label="field.name + '：'" label-width="110px">
            <el-input clearable type="textarea" v-model="config[field.key]" :placeholder="field.memo" :autosize="{ minRows: 2, maxRows: 4}"></el-input>
        </el-form-item>
    </div>
</template>

<style lang="scss" scoped>

</style>

<script>

  /**
   * Created by huangdonglin on 2018/1/3.
   */
  export default {
    name: 'tms-type-textarea',
    props: {
      field: {
        type: [Object, Array],
        required: true
      },
      config: {
        type: Object,
        default() {
          return {}
        }
      }
    },
    data() {
      return {}
    },

    created() {
    },

    components: {},

    mounted() {

    },

    methods: {}
  }

</script>
